/**
 * Badge — small status pill.
 *
 * Tones map to the semantic status palette (success / warning / danger /
 * info / neutral / brand). Variant 'soft' = filled with soft bg; 'solid'
 * = filled with solid bg + white text; 'outline' = transparent bg + ring.
 *
 * Usage:
 *   <Badge tone="success">Active</Badge>
 *   <Badge tone="warning" variant="outline">Pending</Badge>
 */

const TONES = {
  soft: {
    brand:   'bg-brand-soft text-brand',
    success: 'bg-success-soft text-success',
    warning: 'bg-warning-soft text-warning',
    danger:  'bg-danger-soft text-danger',
    info:    'bg-info-soft text-info',
    neutral: 'bg-neutral-soft text-ink-secondary',
  },
  solid: {
    brand:   'bg-brand text-white',
    success: 'bg-success text-white',
    warning: 'bg-warning text-white',
    danger:  'bg-danger text-white',
    info:    'bg-info text-white',
    neutral: 'bg-ink-secondary text-white',
  },
  outline: {
    brand:   'border border-brand/40 text-brand',
    success: 'border border-success/40 text-success',
    warning: 'border border-warning/40 text-warning',
    danger:  'border border-danger/40 text-danger',
    info:    'border border-info/40 text-info',
    neutral: 'border border-border text-ink-secondary',
  },
}

const SIZES = {
  xs: 'px-1.5 py-0 text-[10px] h-4',
  sm: 'px-2   py-0.5 text-[11px]',
  md: 'px-2.5 py-0.5 text-xs',
}

export default function Badge({
  tone = 'neutral',
  variant = 'soft',
  size = 'md',
  className = '',
  children,
  ...rest
}) {
  const cls = (TONES[variant] || TONES.soft)[tone] || TONES.soft.neutral
  return (
    <span
      className={`inline-flex items-center gap-1 font-medium rounded-full ${SIZES[size] || SIZES.md} ${cls} ${className}`}
      {...rest}
    >
      {children}
    </span>
  )
}
